import ReceivablesSideBar from "../ReceviablesSideBar";
import receCss from "../../../css/receivablesListing.module.css";
import React from "react";
import { useState, useEffect, useRef } from "react";
import { useHistory, useParams } from "react-router-dom";
import Select from "react-select";
import swal from "sweetalert";
import { toast } from "react-toastify";


import { ReactComponent as FilterIcon } from "../../../assets/icons/filter.svg";
import { ReactComponent as Plus } from "../../../assets/icons/plus.svg";
import { ReactComponent as CalenderIcon } from "../../../assets/icons/calenderIcon.svg";
import { ReactComponent as CustModeLCloseIcon } from "../../../assets/icons/custModeLCloseIcon.svg";
import { ReactComponent as LoansUploadIcon } from "../../../assets/icons/loansUploadIcon.svg";
import { ReactComponent as RemoveLoanIcon } from "../../../assets/icons/removeLoansIcons.svg";

import UploadExcel from "../../../assets/icons/tbExcelUpload.svg";
import PullERP from "../../../assets/icons/tbPullERP.svg";

import AddIcon from "../../../assets/icons/addEcl.svg";
import Success from "../../../assets/icons/successsym.png";
import { ReactComponent as ErpCardDots } from "../../../assets/icons/erpCardDots.svg";
import { ReactComponent as ErpClock } from "../../../assets/icons/erpClock.svg";
import UserTwoImg from "../../../assets/imgs/user2.png";
import circle from "../../../assets/icons/questioncircle.png";
import { useLocation } from "react-router-dom";
import {
  receivablesListing,
  receivablesUploadFiles,
  GetReceivableMapping,
  saveReceivableMapping,
  GetSubReceivableMapping,
  subReceivablemapping,
  getAllReceivablesErpData,
  putReceivableFromERP,
  getAllCategoryReceivable,
  saveReceivableMappingName,
  getAllReceivableMappings,
} from "../../../../Bookclosure/Services/ApiHandler";

import UploadExcelModal from "../../receivableselements/UploadExcelModal";
import Table from "../../../elements/Table";
import ReceivablesUploadedFile from "../../receivableselements/ReceivablesUploadedFile";
import ReceivableListingFilterModel from "../../../components/receivables/Listing/ListingReceivableFilterModel";
import commoncss from "../../../css/common.module.css";
import ImportMappingPopup from "../../receivableselements/SaveImportMappingPopup/ImportMappingPopup";
import DataState from "../../receivableselements/DataState";
import AddField from "../../receivableselements/AddField";
import SaveMappingPopup from "../../receivableselements/SaveImportMappingPopup/SaveMappingPopup";
import AppendReplacePopup from "../../receivableselements/AppendReplacePopup";
import { BackArrowButton } from "../../../fixedassetelements/button/Button";
import { motion, AnimatePresence } from "framer-motion";

const modalVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
  },
};

const popupVariants = {
  hidden: {
    y: "100vh",      
    opacity: 0,
  },
  visible: {
    y: 0,         
    opacity: 1,
    transition: {
      type: "spring",
      stiffness: 120,
      damping: 20,
      mass: 1.2,
    },
  },
};


const normalize = (val = "") =>
  val.toString().trim().toLowerCase();

const LoansListing = () => {
 // const [receivablesID, setreceivablesID] = useState('676cf724e5e1156fbf63b571')
//  const STATIC_RECEIVABLES_ID = "685a3dcafd8a703cbc9bff9f";

  const { id, companyId } = useParams();

  const location = useLocation();
  const { companyName: passedCompanyName, regName: passedRegName } =
    location.state || {};

  const [companyName, setCompanyName] = useState(passedCompanyName || "");
  const [regName, setRegName] = useState(passedRegName || "Receivables");
  const finalCompanyName = companyName || passedCompanyName || "";
  const finalRegName = regName || passedRegName || "Receivables";

  const [receivablesID, setreceivablesID] = useState(id);
  const [ReceivablesUploadModal, setReceivablesUploadModal] = useState(false);

  const [activeTab, setActiveTab] = useState("Receivables Listing");
  const [subMenuItem, setSubMenuItem] = useState("");
  const [hasData, setHasData] = useState(false);
  // add near other modal states
  const [isMapped, setIsMapped] = useState(false);
  const [showSaveMapping, setShowSaveMapping] = useState(false); 
  const [currentMappingFileIndex, setCurrentMappingFileIndex] = useState(null);
  
  // receivables Mapping model
  const [ReceivablesMapping, setReceivablesMapping] = useState(false);
  const[totalValue, setTotalValue] = useState(0);
  const[subtotalValue, setSubTotalValue] = useState(0);
  const [sessionSavedMappings, setSessionSavedMappings] = useState([]);
  const [showImportMapping, setShowImportMapping] = useState(false);

  // receivables Mapping model
  const [subReceivablesMapping, setsubReceivablesMapping] = useState(false);

  // receiables erp items list model
  const [receivablesERPModel, setreceivablesERPModel] = useState(false);
  const [erpSelectedReceivableId, seterpSelectedReceivableId] = useState();

  const [ReceivablesListThData, setReceivablesListThData] = useState();
  const [ReceivablesListTbData, setReceivablesListTbData] = useState();

  const [ReceivablesColumnMapVal, setReceivablesColumnMapVal] = useState({}); 
  const [ReceivablesColumnMap, setReceivablesColumnMap] = useState([]);
  const [isImportApplied, setIsImportApplied] = useState(false);


  const [subMappingActiveTab, setsubMappingActiveTab] = useState(1);

  const [categoryLabels, setCategoryLabels] = useState([]);
  const [currencyLabels, setCurrencyLabels] = useState([]);
  const [currencyExchangeRates, setCurrencyExchangeRates] = useState({});

  const [perCategoryLabels, setperCategoryLabels] = useState();
  const [perCategoryFields, setperCategoryFields] = useState();

  const [perCurrencyLables, setperCurrencyLables] = useState();
  const [perCurrencyFields, setperCurrencyFields] = useState();

  // const [perProductClassfLables, setperProductClassfLables] = useState()
  // const [perProductClassfFields, setperProductClassfFields] = useState()

  const [showAddField, setShowAddField] = useState(false);

  const [showUploadExcelModal, setShowUploadExcelModal] = useState(false);
  const [uploadedFileModal, setUploadedFileModal] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [showAppendReplaceModal, setShowAppendReplaceModal] = useState(false);
  const [selectedMappingName, setSelectedMappingName] = useState(null);
  const sessionStartedAtRef = useRef(Date.now());
  const openUploadExcelModal = (type) => {
    setShowAppendReplaceModal(false);
    setShowUploadExcelModal(true);
  };

  const [selectedSubMappingData, setSelectedSubMappingData] = useState({
    categorySubmap: [],
    currencySubmap: [],
  });
 
  const openSaveMappingPopup = () => {
  setSelectedMappingName(null); 
  setShowSaveMapping(true);    
};

const DEFAULT_COLUMN_MAPPING = {
  customerID: "Supplier code ",
  customerName: "Supplier spmn supname",
  docDate: "Doc Date",
  dueDays: "Due Days",
  dueDate: "Due Date",
  foreignCurrency: "Doc Currency",
  exchangeCurrencyValue: "Exchange Rate",
  GLAccountCode: "Account Code",
  business: "Business",
  businessPersonResponsible: "Business person responsible",
  provision: "Provision",
  category: "O/s category",
  outstandingAmount: "O/S amount",
  invoiceAmount: "Invoice Amount",
  invoiceNumber: "Invoice Number",
  invoiceDate: "Invoice Date",
};

  const [filterAttr, setFilterAttr] = useState([]);
  const [filterLoanData, setFilterLoanData] = useState({});
  const handleSetSelectChange = (selectedOption, index, tab) => {
    if (!selectedOption) return;
    let label = "";
    let targetKey = "";

    if (tab === "Category") {
      label = perCategoryLabels[index];
      targetKey = "categorySubmap";
    } else if (tab === "Currency") {
      label = perCurrencyLables[index];
      targetKey = "currencySubmap";
    }

    setSelectedSubMappingData((prev) => {
      const updated = [...(prev[targetKey] || [])];

      if (tab === "Currency") {
        updated[index] = {
          key: label || "",
          values: "",
        };

        setCurrencyLabels((prev) => {
          const updatedLabels = [...prev];
          updatedLabels[index] = label;
          return updatedLabels;
        });
      } else {
        updated[index] = {
          key: label || "",
          values: [selectedOption.value],
        };
      }

      return {
        ...prev,
        [targetKey]: updated,
      };
    });
  };

useEffect(() => {
  if (!ReceivablesColumnMap.length) return;
  if (isImportApplied) return;

  const autoMapped = {};
  Object.entries(DEFAULT_COLUMN_MAPPING).forEach(([key, label]) => {
    const match = ReceivablesColumnMap.find(
      (opt) => normalize(opt.value) === normalize(label)
    );
    if (match) {
      autoMapped[key] = match.value;
    }
  });
  

  setReceivablesColumnMapVal(autoMapped);
}, [ReceivablesColumnMap, isImportApplied]);



  useEffect(() => {
    // // This code inside useEffect will run only once after the component first mounts.
    // setReceivablesColumnMapVal({
    // "customerID": "",
    // "customerName": "",
    // "docDate": "",
    // "dueDays": "",
    // "dueDate": "",
    // "foreignCurrency": "",
    // "exchangeCurrencyValue": "",
    // "GLAccountCode": "",
    // "business": "",
    // "businessPersonResponsible": "",
    // "provision": "",
    // "category": ""
    // });
  }, []);
  const [filterOptions, setFilterOptions] = useState({});
  useEffect(() => {
    const getFilterOptions = async () => {
      try {
        const response = await receivablesListing(receivablesID);
        const allLoans = response.data.receivableListing;
        // Create a single object with all unique values
        const uniqueOptions = {
          customerIDs: [...new Set(allLoans.map((loan) => loan.customerID))],
          customerNames: [
            ...new Set(allLoans.map((loan) => loan.customerName)),
          ],
          productIDs: [...new Set(allLoans.map((loan) => loan.productID))],
          productNames: [...new Set(allLoans.map((loan) => loan.productName))],
          loanIDs: [...new Set(allLoans.map((loan) => loan.loanID))],
        };
        // Update the state with the single object
        setFilterOptions(uniqueOptions);
        console.log("Filter options:", uniqueOptions);
      } catch (error) {
        console.error("Failed to fetch filter options:", error);
      }
    };
    getFilterOptions();
  }, [receivablesID]);



  // Loans listing api
  useEffect(() => {
    getReceivableListingData(receivablesID, filterLoanData);

    // receivablesListing(receivablesID).then((res) => {
    //     const headers = res?.data?.receivableListingHeaders.map((h) => ({
    //     header: h,
    //     accessor: h,
    //     }));
    //     setReceivablesListThData(headers);
    //     setReceivablesListTbData(res?.data?.receivableListing);
    // });
  }, []);

const handleImportMapping = (importedMapping) => {
  if (!importedMapping) return;
  const mappingNameOption = {
    value: importedMapping.name,
    label: importedMapping.name,
  };
  setReceivablesColumnMap((prev) => {
    const exists = prev.some(
      (opt) => opt.value === importedMapping.name
    );
    return exists ? prev : [...prev, mappingNameOption];
  });

  setReceivablesColumnMapVal(importedMapping.columnMap);

  setIsImportApplied(true);

  setShowImportMapping(false);
};
  
  const getReceivableListingData = (receivablesID, filterLoanData) => {
    receivablesListing(receivablesID, filterLoanData).then((res) => {
      const displayHeaderMap = {
        customerID: "Customer ID",
        customerName: "Customer Name",
        docDate: "Doc Date",
        dueDays: "Due days",
        dueDate: "Due date",
        foreignCurrency: "Doc Currency",
        exchangeCurrencyValue: "Exchange Rate",
        GLAccountCode: "Account Code",
        business: "Business",
        businessPersonResponsible: "Business person responsible",
        provision: "Provision",
        category: "O/s category",
        outstandingAmount: "O/S amount",
        invoiceAmount: "Invoice Amount",
        invoiceNumber: "Invoice Number",
        invoiceDate: "Invoice Date"
      };
      const headers = res.data.receivableListingHeaders.map((h) => ({
        // header: h,
        header: displayHeaderMap[h] || h,
        accessor: h,
      }));
      setReceivablesListThData(headers);
      setReceivablesListTbData(res.data.receivableListing);

      setTotalValue(res.data.total);
      setSubTotalValue(res.data.subtotal);

      if (res.data.filterAndAlignment) {
        setFilterAttr(res.data.filterAndAlignment);
      }
    });
  };

  const fileInputRef = useRef(null);
  const handleManualUpload = () => {
    fileInputRef.current.click();
  };

  const fetchSessionMappings = async () => {
  try {
    const res = await getAllReceivableMappings(companyId);

    const allMappings = res?.data?.receivableMappingArray || [];
    const sessionOnlyMappings = allMappings.filter((m) => {
      if (!m.createdAt) return false;
      return (
        new Date(m.createdAt).getTime() >= sessionStartedAtRef.current
      );
    });

    const formatted = sessionOnlyMappings.map((m) => ({
      id: m._id,
      name: m.name,
      columnMap: {
        customerID: m.customerID,
        customerName: m.customerName,
        docDate: m.docDate,
        dueDays: m.dueDays,
        dueDate: m.dueDate,
        foreignCurrency: m.foreignCurrency,
        exchangeCurrencyValue: m.exchangeCurrencyValue,
        GLAccountCode: m.GLAccountCode,
        business: m.business,
        businessPersonResponsible: m.businessPersonResponsible,
        provision: m.provision,
        category: m.category,
        outstandingAmount: m.outstandingAmount,
        invoiceAmount: m.invoiceAmount,
      },
      companyName: m.companyName,
    }));
   console.log("Fetched session mappings:", formatted);
    setSessionSavedMappings(formatted);     
  } catch (err) {
    console.error("Failed to fetch mappings", err);
  }
};


  const handleSelectChange = (keyName, selectedOption) => {
    setReceivablesColumnMapVal((prevMapping) => ({
      ...prevMapping,
      [keyName]: selectedOption ? selectedOption.value : "",
    }));
  };

  const GetLoanMappingData = (fileIndex = null) => {

     sessionStartedAtRef.current = Date.now();
     setSessionSavedMappings([]);
     setShowImportMapping(false);
  
    GetReceivableMapping(receivablesID).then((res) => {
    const loansFieldsLst = res.data.fields;

    const formattedOptions = loansFieldsLst.map((field) => ({
      value: field,
      label: field,
    }));

    setReceivablesColumnMap(formattedOptions);
    if (fileIndex !== null) {
      setCurrentMappingFileIndex(fileIndex);
    }    

    setReceivablesMapping(true);
  });
};

    
const continueWithColumnMapping = () => {
   saveReceivableMapping(receivablesID, ReceivablesColumnMapVal).then((res) => {
    setReceivablesMapping(false);
    GetSubLoanMappingData();
    setsubReceivablesMapping(true);
  });
};

 const handleSaveMappingWithName = async (name) => {
  try {
    const res = await saveReceivableMappingName(
      companyId,
      name,
      ReceivablesColumnMapVal
    );
    setSessionSavedMappings([
      {
        id: res?.data?._id || Date.now(),
        name,
        columnMap: ReceivablesColumnMapVal,
        companyName: finalCompanyName,
      },
    ]);
    setShowSaveMapping(false);
  } catch (err) {
    toast.error("Failed to save mapping");
  }
};


  useEffect(() => {
    if (receivablesID && companyId) {
      GetSubReceivableMapping(receivablesID, "category")
        .then((res) => {
          if (res.data && res.data.fields && res.data.fields.length > 0) {
            GetSubLoanMappingData();
          }
        })
        .catch((err) => {
          console.log("No existing sub-mapping data found");
        });
    }
  }, [receivablesID, companyId]);

  const GetSubLoanMappingData = () => {
    getAllCategoryReceivable(companyId).then((catRes) => {
      const definedCategories = catRes.data.categoryList.map((c) => c.name);

      GetSubReceivableMapping(receivablesID, "category").then((res) => {
        let receFieldsLst = res.data.fields;
        let labelList = res.data.labelList;
        let dataList = res.data.dataList || [];

        const formattedOptions = receFieldsLst.map((field) => ({
          value: field,
          label: field,
        }));

        setperCategoryFields(formattedOptions);
        // setperCategoryLabels(labelList);
        // setCategoryLabels(dataList);

        setperCategoryLabels(definedCategories);

        const newCategoryLabels = definedCategories.map((catName) => {
          const index = labelList.indexOf(catName);
          return index !== -1 ? dataList[index] : "";
        });

        setCategoryLabels(newCategoryLabels);

        const existingCategoryMappings = definedCategories
          .map((catName, idx) => {
            const mappedValue = newCategoryLabels[idx];
            return mappedValue
              ? {
                  key: catName,
                  values: [mappedValue],
                }
              : null;
          })
          .filter(Boolean);

        setSelectedSubMappingData((prev) => ({
          ...prev,
          categorySubmap: existingCategoryMappings,
        }));
      });
    });

    GetSubReceivableMapping(receivablesID, "foriegnCurrency").then((res) => {
      let receFieldsLst = res.data.fields;
      let labelList = res.data.labelList;
      let dataList = res.data.dataList || [];

      const formattedOptions = receFieldsLst.map((receFieldsLst) => ({
        value: receFieldsLst,
        label: receFieldsLst,
      }));

      setperCurrencyFields(formattedOptions);
      setperCurrencyLables(labelList);

      setCurrencyLabels(dataList);
      const rateMapping = {};
      receFieldsLst.forEach((field, idx) => {
        rateMapping[field] = idx + 1;
      });
      setCurrencyExchangeRates(rateMapping);

      const existingCurrencyMappings = labelList
        .map((currName, idx) => {
          const mappedValue = dataList[idx];
          return mappedValue
            ? {
                key: currName,
                values: Number(mappedValue),
              }
            : null;
        })
        .filter(Boolean);

      setSelectedSubMappingData((prev) => ({
        ...prev,
        currencySubmap: existingCurrencyMappings,
      }));
    });
  };

  const saveSubMapping = () => {
    const hasValidMappings =
      (selectedSubMappingData.categorySubmap &&
        selectedSubMappingData.categorySubmap.length > 0) ||
      (selectedSubMappingData.currencySubmap &&
        selectedSubMappingData.currencySubmap.length > 0);

    if (!hasValidMappings) {
      console.error("Please map at least one field before continuing.");
      return;
    }

    const payload = {
      categorySubmap: (selectedSubMappingData.categorySubmap || []).map(
        (item) => ({
          key: item.key,
          values: item.values,
        })
      ),

      currencySubmap: (selectedSubMappingData.currencySubmap || []).map(
        (item) => ({
          key: item.key || item.currencyCode,
          values: Number(item.values ?? item.exchangeRate),
        })
      ),
    };

    console.log(
      "FINAL PAYLOAD SENT TO BACKEND:",
      JSON.stringify(payload, null, 2)
    );

    subReceivablemapping(receivablesID, payload)
      .then((res) => {
        setsubReceivablesMapping(false);
        toast.success("Receivables added successfully.");
       if (currentMappingFileIndex !== null) {
        setUploadedFiles(prev =>
          prev.map((file, i) =>
            i === currentMappingFileIndex ? { ...file, mapped: true } : file
          )
        );
      }
        setCurrentMappingFileIndex(null);
        setUploadedFileModal(true);
        setTimeout(() => {
          getReceivableListingData(receivablesID, filterLoanData);
        }, 500);
      })
      .catch((error) => {
        console.error("Sub-mapping error:", error);
        const errorMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Failed to save sub-mapping";
        toast.error(errorMessage);
      });
  };

  const [receivableSelectModel, setloanSelectModel] = useState(false);
  const [erpList, setErpList] = useState([]);

  const [selectedCardId, setSelectedCardId] = useState(null);

  const handleModels = (model) => {
    setloanSelectModel(false);

    if (model === "erp") {
      GetErpData();
    }

    if (model === "uploadLoansFile") {
      setShowUploadExcelModal(true);
    }

    const handleRemoveFile = (index) => {
      setUploadedFiles((prev) => {
        const updated = [...prev];
        updated.splice(index, 1);
        return updated;
      });

      setTimeout(() => {
        if ((uploadedFiles.length || 0) - 1 <= 0) {
          setUploadedFileModal(false);
        }
      }, 0);
    };

  };

  const GetErpData = () => {
    getAllReceivablesErpData(receivablesID).then((res) => {
      setErpList(res.data.ERPReceivableList);
      setreceivablesERPModel(true);
    });
  };

  const setReceivableId = () => {
    if (selectedCardId) {
      putReceivableFromERP(receivablesID, selectedCardId).then(() => {
        toast.success("ERP data pulled successfully");
        setreceivablesERPModel(false);
      });
    }
  };

    const handleRemoveFile = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
    };


   const handleRefreshMapping = (fileIndex) => {
   setUploadedFiles(prev =>
     prev.map((file, i) =>
       i === fileIndex ? { ...file, mapped: false } : file
     )
    );
  };

  const applyReceivablesListingFilter = (filterParams) => {
    setFilterLoanData(filterParams);
    getReceivableListingData(receivablesID, filterParams);
  };
  return (
    <div style={{ display: "flex" }}>
      <ReceivablesSideBar
        activeTab={activeTab}
        subMenuItem={subMenuItem}
        id={id}
        companyId={companyId}
        companyName={finalCompanyName}
        regName={finalRegName}
      />
      <div className={receCss.loanListingMainContainer}>
        <ReceivablesListingHeader
          setloanSelectModel={setloanSelectModel}
          setReceivablesUploadModal={setReceivablesUploadModal}
          filterAttr={filterAttr}
          receivablesID={receivablesID}
          applyReceivablesListingFilter={applyReceivablesListingFilter}
          filterOptions={filterOptions}
          openAppendReplace={() => setShowAppendReplaceModal(true)}
          hasData={hasData}
          total={totalValue}
          subtotal={subtotalValue}
        />
        <ReceivablesListingBody
          hasData={hasData}
          ReceivablesListThData={ReceivablesListThData}
          ReceivablesListTbData={ReceivablesListTbData}
          setloanSelectModel={setloanSelectModel}
        />
         
         <AnimatePresence>
          {receivableSelectModel && (
          <SelectDataPullMethod
            key="select-data-pull"
            setloanSelectModel={setloanSelectModel}
            handleModels={handleModels}
          />
          )}
        </AnimatePresence>


        {showAppendReplaceModal && (
          <AppendReplacePopup
            onClose={() => setShowAppendReplaceModal(false)}
            onSelectUploadType={(type) => openUploadExcelModal(type)}
          />
        )}

        {ReceivablesUploadModal && (
          <React.Fragment>
            <ReceivablesUploadModel
              fileInputRef={fileInputRef}
              handleManualUpload={handleManualUpload}
              setReceivablesUploadModal={setReceivablesUploadModal}
              receivablesID={receivablesID}
              setReceivablesMapping={setReceivablesMapping}
              GetLoanMappingData={GetLoanMappingData}
              setUploadedFiles={setUploadedFiles}
              setUploadedFileModal={setUploadedFileModal}
              setShowUploadExcelModal={setShowUploadExcelModal}
            />
          </React.Fragment>
        )}

        {uploadedFileModal && (
          <ReceivablesUploadedFile
            uploadedFiles={uploadedFiles}
            isMapped={isMapped}
            handleRemoveFile={handleRemoveFile}
            onRefreshMapping={handleRefreshMapping}
            onBack={() => setUploadedFileModal(false)}
            onClose={() => setUploadedFileModal(false)}
            onStartMapping={(fileIndex) => {
              setCurrentMappingFileIndex(fileIndex);
              setUploadedFileModal(false);
              GetLoanMappingData(fileIndex);
            }}
            onFinish={() => {
              setUploadedFileModal(false);
              getReceivableListingData(receivablesID, filterLoanData);
              setHasData(true);
            }}
            onNavigateToUpload={() => {
              setUploadedFileModal(false);
              setReceivablesUploadModal(true);
            }}
            onAdd={() => {
              setUploadedFileModal(false);
              setReceivablesUploadModal(true);
            }}
          />
        )}

        {showImportMapping && (
        <ImportMappingPopup
         savedMappings={sessionSavedMappings}
         onClose={() => setShowImportMapping(false)}
         onImport={handleImportMapping}
         /> 
        )}
        {receivablesERPModel && (
          <React.Fragment>
            <ReceivablesERPItemsModel
              selectedCardId={selectedCardId}
              setSelectedCardId={setSelectedCardId}
              erpList={erpList}
              erpSelectedReceivableId={erpSelectedReceivableId}
              seterpSelectedReceivableId={seterpSelectedReceivableId}
              setreceivablesERPModel={setreceivablesERPModel}
              setReceivableId={setReceivableId}
            />
          </React.Fragment>
        )}

        {showUploadExcelModal && (
          <UploadExcelModal
            onClose={() => setShowUploadExcelModal(false)}
            onBack={() => {
              setShowUploadExcelModal(false);
              setloanSelectModel(true);
            }}
            onSelectUploadType={() => {
              setShowUploadExcelModal(false);
              setReceivablesUploadModal(true);
            }}
          />
        )}

        {ReceivablesMapping && (
          <React.Fragment>
            <ReceivablesMappingModel
              ReceivablesColumnMap={ReceivablesColumnMap}
              ReceivablesColumnMapVal={ReceivablesColumnMapVal}
              handleSelectChange={handleSelectChange}
              setReceivablesMapping={setReceivablesMapping}
              setUploadedFileModal={setUploadedFileModal}
              showSaveMapping={showSaveMapping}
              setShowSaveMapping={setShowSaveMapping}
              handleSaveMappingWithName={handleSaveMappingWithName}
              companyId={companyId}
              setSelectedMappingName={setSelectedMappingName}
              selectedMappingName={selectedMappingName}
              continueWithColumnMapping={continueWithColumnMapping}
              openSaveMappingPopup={openSaveMappingPopup}
              onOpenImportMapping={() => {
               fetchSessionMappings();
               setShowImportMapping(true);
              }}
            />
          </React.Fragment>
        )}



        {subReceivablesMapping && (
          <React.Fragment>
            <SubReceivablesMappingModel
              subReceivablesMapping={subReceivablesMapping}
              setsubReceivablesMapping={setsubReceivablesMapping}
              subMappingActiveTab={subMappingActiveTab}
              setsubMappingActiveTab={setsubMappingActiveTab}
              perCategoryLabels={perCategoryLabels}
              perCategoryFields={perCategoryFields}
              perCurrencyLables={perCurrencyLables}
              perCurrencyFields={perCurrencyFields}
              categoryLabels={categoryLabels}
              currencyLabels={currencyLabels}
              // perProductClassfLables={perProductClassfLables}
              // perProductClassfFields={perProductClassfFields}
              handleSetSelectChange={handleSetSelectChange}
              selectedSubMappingData={selectedSubMappingData}
              setSelectedSubMappingData={setSelectedSubMappingData}
              saveSubMapping={saveSubMapping}
              showAddField={showAddField}
              setShowAddField={setShowAddField}
              setUploadedFileModal={setUploadedFileModal}
              setReceivablesMapping={setReceivablesMapping}
            />
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default LoansListing;
const SelectDataPullMethod = ({ handleModels, setloanSelectModel }) => {
  return (
   
      <motion.div
        className={receCss.cutModelForDragLaonsIrac}
        variants={modalVariants}
        initial="hidden"
        animate="visible"
        exit="hidden"
      >

    <motion.div
      className={commoncss.modalWrapper}
      variants={popupVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >

        <div className={commoncss.contentWrapper}>
          <div className={commoncss.header}>
            <div>Add Receivables data</div>

            <CustModeLCloseIcon
              className={`${receCss.custModelHeaderCloseicon} ${receCss.cursiorPointer}`}
              onClick={() => setloanSelectModel(false)}
            />
          </div>

          <div className={commoncss.cardRow}>
            <div
              className={commoncss.cardContainer}
              onClick={() => handleModels("erp")}
            >
              <div className={commoncss.imageWrapper}>
                <img
                  src={PullERP}
                  alt="ERPImg"
                  className={commoncss.cardImage}
                />
              </div>

              <div className={commoncss.container}>
                <h4 className={commoncss.cardTitle}>Pull from ERP</h4>
                <p className={commoncss.cardDescription}>
                  Select your ERP pull package from the connectors page for
                  seamless integration to your ERP data.
                </p>
              </div>
            </div>

            <div
              className={commoncss.cardContainer}
              onClick={() => handleModels("uploadLoansFile")}
            >
              <div className={commoncss.imageWrapper}>
                <img
                  src={UploadExcel}
                  alt="Uploadfile"
                  className={commoncss.cardImage}
                />
              </div>

              <div className={commoncss.container}>
                <h4 className={commoncss.cardTitle}>Upload as Excel File</h4>
                <p className={commoncss.cardDescription}>
                  Upload your manual register in xlsx or csv formats and map
                  your columns for data import
                </p>
              </div>
            </div>
          </div>
        </div>
       </motion.div>
    </motion.div>
  );
};
const ReceivablesListingHeader = ({
  setReceivablesUploadModal,
  setloanSelectModel,
  filterAttr,
  receivablesID,
  applyReceivablesListingFilter,
  filterOptions,
  openAppendReplace,
  hasData,
  total,
  subtotal,
}) => {
  const [displayModal, setDisplayModal] = useState(false);
  const [receivablelistingFilterModel, setReceivableListingFilterModel] =
    useState(false);

  const closeListingFilterModal = () => {
    setDisplayModal(false);
  };
  return (
    <>
      <div className={receCss.w100}>
        <div className={receCss.uploadLoansMainContainer}></div>
        <div className={receCss.listPageheader}>
          <div className={receCss.loanHeaderLeftContainer}>
            <div className={receCss.heading}>Receivables Listing</div>
          </div>
          <div className={receCss.loanHeaderRightContainer}>
            {hasData && (total !== undefined || subtotal !== undefined) && (
            <div className={receCss.totalSubtotalContainer}>
              {total !== undefined && (
                <div className={receCss.totalItem}>
                  <span className={receCss.totalLabel}>Total</span>
                  <span className={receCss.totalValue}>{total}</span>
                </div>
              )}
              {subtotal !== undefined && (
                <div className={receCss.subtotalItem}>
                  <span className={receCss.subtotalLabel}>SubTotal</span>
                  <span className={receCss.subtotalValue}>{subtotal}</span>
                </div>
               )}
              </div>
             )} 
            <div className={receCss.filterContainer}>
              {/* <FilterIcon /> */}
              <FilterIcon
                className={commoncss.clickable}
                width={20}
                height={20}
                onClick={() => {
                  setReceivableListingFilterModel(true);
                  setDisplayModal(true);
                }}
              />
            </div>
            {/* <div className={receCss.calenderContainer}>
              <div className={receCss.leftCalenderContainer}>
                <div className={receCss.calenderLabels}>From</div>
                <div className={receCss.calenderDate}>01-01-2024</div>
                <div className={receCss.calenderIconContainer}>
                  <CalenderIcon />
                </div>
              </div>

              <div className={receCss.RightCalenderContainer}>
                <div className={receCss.calenderLabels}>To</div>
                <div className={receCss.calenderDate}>01-01-2024</div>
                <div className={receCss.calenderIconContainer}>
                  <CalenderIcon />
                </div>
              </div>
            </div> */}
            <div className={receCss.btnWrapper}>
             <button onClick={() => {
                  if (hasData) {
                    openAppendReplace();      
                  } else {
                  setloanSelectModel(true);  
                  }
                 }}
               type="button"
               className={receCss.uploadPrimaryBtn}   
              >
              <Plus className={`${receCss.plusIcon}`} />
                {hasData ? "Upload" : "Add Register"}  
              </button>
            </div>
          </div>
        </div>
      </div>
      {receivablelistingFilterModel && displayModal && (
        <ReceivableListingFilterModel
          handleClose={closeListingFilterModal}
          setReceivableListingFilterModel={setReceivableListingFilterModel}
          filterOptions={filterOptions}
          receivablesID={receivablesID}
          applyReceivablesListingFilter={applyReceivablesListingFilter}
          filterAttr={filterAttr}
        />
      )}
    </>
  );
};

const ReceivablesListingBody = ({
  hasData,
  ReceivablesListThData,
  ReceivablesListTbData,
  setloanSelectModel,
}) => {
  const [colWidths, setColWidths] = useState([]);

  useEffect(() => {
    const ths = document.querySelectorAll(`.${receCss.stickyTh} th`);
    const widths = Array.from(ths).map((th) => {
      const style = window.getComputedStyle(th);
      const paddingLeft = parseFloat(style.paddingLeft) || 0;
      const paddingRight = parseFloat(style.paddingRight) || 0;
      const borderLeft = parseFloat(style.borderLeftWidth) || 0;
      const borderRight = parseFloat(style.borderRightWidth) || 0;

      return (
        th.offsetWidth - paddingLeft - paddingRight - borderLeft - borderRight
      );
    });
    setColWidths(widths);
  }, [ReceivablesListTbData, ReceivablesListThData]);

  const TruncCell = ({ content, maxWidth }) => {
    const wrapperRef = useRef(null);
    const [tooltip, setTooltip] = useState(null);

    const isTruncated = () =>
      wrapperRef.current &&
      wrapperRef.current.scrollWidth > wrapperRef.current.clientWidth;

    return (
      <>
        <div
          ref={wrapperRef}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            boxSizing: "border-box",
            maxWidth: `${maxWidth}px`,
          }}
          onMouseEnter={(e) => {
            if (!isTruncated()) return;
            const rect = e.target.getBoundingClientRect();
            setTooltip({
              text: content,
              x: rect.left + rect.width / 2,
              y: rect.top,
            });
          }}
          onMouseLeave={() => setTooltip(null)}
        >
          {content}
        </div>

        {tooltip && (
          <div
            style={{
              position: "fixed",
              top: tooltip.y - 28,
              left: tooltip.x,
              transform: "translateX(-50%)",
              backgroundColor: "#333",
              color: "#fff",
              padding: "4px 8px",
              borderRadius: "4px",
              fontSize: "12px",
              whiteSpace: "nowrap",
              zIndex: 9999,
              pointerEvents: "none",
            }}
          >
            {tooltip.text}
          </div>
        )}
      </>
    );
  };

  if (!hasData) {
    return <DataState onAdd={() => setloanSelectModel(true)} />;
  }

  if (!ReceivablesListTbData || ReceivablesListTbData.length === 0) {
    return <DataState onAdd={() => setloanSelectModel(true)} />;
  }

  return (
    <div className={receCss.tableContianerCust}>
      <div className={`${receCss.tableContainer} ${receCss.customscroll}`}>
        <table className={receCss.customTable}>
          <thead>
            <tr className={receCss.stickyTh}>
              {ReceivablesListThData?.map((col, i) => (
                <th key={i}>{col.header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ReceivablesListTbData.map((row, i) => (
              <tr key={i}>
                {ReceivablesListThData?.map((col, j) => (
                  <td key={j} className={receCss.truncate}>
                    <TruncCell
                      content={row[col.accessor]}
                      maxWidth={colWidths[j] || 100}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const ReceivablesUploadModel = ({
  setReceivablesUploadModal,
  fileInputRef,
  handleManualUpload,
  setShowUploadExcelModal,
  receivablesID,
  setReceivablesMapping,
  GetLoanMappingData,
  setUploadedFiles,
  setUploadedFileModal,
}) => {
  const [dragActive, setDragActive] = useState(false);

  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);
  const [files, setFiles] = useState([]);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleBack = () => {
    setReceivablesUploadModal(false);
    setShowUploadExcelModal(true);
  };

  const handleChangeFile = () => {
    setShowUploadExcelModal(true);
    setReceivablesUploadModal(false);
    
  }

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    const droppedFiles = Array.from(e.dataTransfer.files);

    setFiles((prev) => [...prev, ...droppedFiles]);
    setUploadError("");
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);

    const invalid = selectedFiles.some(
      (file) =>
        !file.name.toLowerCase().endsWith(".xls") &&
        !file.name.toLowerCase().endsWith(".xlsx")
    );

    if (invalid) {
      setUploadError(
        "Invalid file format. Please upload Excel files (.xls or .xlsx)."
      );
      return;
    }

    setUploadError("");
    setFiles((prev) => [...prev, ...selectedFiles]);
  };

  const handleRemoveFile = () => {
    setFiles([]);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  const uploadFileToApi = async () => {
    if (!files || files.length === 0) {
      setUploadError("Please select a file to upload.");
      return;
    }

    if (!receivablesID) {
      setUploadError("Receivable ID is missing. Cannot upload file.");
      return;
    }

    setUploading(true);
    setUploadError(null);

    const formData = new FormData();

    files.forEach((f) => {
      formData.append("file", f);
    });

    try {
      const result = await receivablesUploadFiles(receivablesID, formData);
      console.log("Upload successful:", result);
      setReceivablesUploadModal(false);

      const newFiles = files.map((f) => ({
        name: f.name,
        mapped: false,
        raw: f,
        response: result,
      }));
      setUploadedFiles(prev => [...prev, ...newFiles]);
      setUploadedFileModal(true);
    } catch (error) {
      console.error("Error uploading file:", error);

      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred during upload.";

      setUploadError(errorMessage);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div
      className={`${receCss.cutModelForDragLaonsIrac} custmfadein`}
      onClick={() => {
        setReceivablesUploadModal(false);
      }}
    >
      <div
        className={receCss.cutmModelMainContainer}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={receCss.custModelHeader} style={{ padding: '10px 20px 10px 10px'}}>
          <div className={receCss.headerLeftSection}>
            <BackArrowButton onClick={handleBack} />
            <h2 className={receCss.custModelHeaderLabel}>
              Upload Receivable Register
            </h2>
          </div>

          <div className={receCss.custmCursor}>
            <CustModeLCloseIcon
              className={`${receCss.custModelHeaderCloseicon} ${receCss.cursiorPointer}`}
              onClick={() => setReceivablesUploadModal(false)}
            />
          </div>
        </div>

        <div className={receCss.cutModelBodyContainerOne}>
          <div className={receCss.uploadSheetsRow}>
            <span className={receCss.uploadAsSheets}>Upload as sheets</span>
            <span className={receCss.changeLink} onClick={handleChangeFile}>Change</span>
          </div>

          <div
            className={`${receCss.dragDropArea} ${
              dragActive ? receCss.dragActive : ""
            }`}
            onDragEnter={handleDrag}
            onDragOver={handleDrag}
            onDragLeave={handleDrag}
            onDrop={handleDrop}
          >
            <label htmlFor="file-upload" className={receCss.dragDropLabel}>
              Drag and drop your file here or
              <button
                type="button"
                onClick={handleManualUpload}
                className={receCss.custModelUploadBtn}
              >
                <LoansUploadIcon className={receCss.receUploadIcon} />
                &nbsp; Upload
              </button>
            </label>
            <input
              id="file-upload"
              type="file"
              onChange={handleFileChange}
              className={receCss.hiddenFileInput}
              ref={fileInputRef}
            />
          </div>

          <div className={receCss.uploadInfoSection}>
            {files.length > 0 ? (
              <div className={receCss.uploadStatus}>
                <img src={Success} alt="success" />
                <p className={receCss.uploadCount}>
                  {files.length} file(s) uploaded
                </p>
              </div>
            ) : (
              <p className={receCss.note}>
                File you upload must contain all the mandatory fields for
                mapping.
              </p>
            )}

            {uploadError && <p className={receCss.errorText}>{uploadError}</p>}
          </div>
        </div>

        <div className={receCss.cutModelFooterContainer}>
          <button
            type="button"
            onClick={() => setReceivablesUploadModal(false)}
            className={receCss.custModelFooterBtnSecondary}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={uploadFileToApi}
            className={receCss.custModelFooterBtnPrimary}
            disabled={
              uploading || !files || files.length === 0 || !receivablesID
            }
          >
            {uploading ? "Uploading..." : "Proceed"}
          </button>
        </div>
      </div>
    </div>
  );
};

const ReceivablesMappingModel = ({
  ReceivablesColumnMap,
  ReceivablesColumnMapVal,
  handleSelectChange,
  continueWithColumnMapping,
  setReceivablesMapping,
  setUploadedFileModal,
  onBackToUploadedFiles,
  showSaveMapping,
  setShowSaveMapping,
  handleSaveMappingWithName,
  companyId,
  openSaveMappingPopup,
  onOpenImportMapping,
}) => {

 const getSelectedOption = (key) => {
  const value = ReceivablesColumnMapVal[key];
  return value ? { value, label: value } : null;
};

const getOptions = () => ReceivablesColumnMap;

const handleBackClick = () => {
    setReceivablesMapping(false);
    if (setUploadedFileModal) {
      setUploadedFileModal(true);
    } else if (onBackToUploadedFiles) {
      onBackToUploadedFiles();
    }
  };
  return (
    <div
      className={`${receCss.cutModelForDragLaonsIrac} custmfadein`}
      onClick={() => {}}
    >
      <div
        className={receCss.cutmModelMainContainerSecond}
        onClick={(e) => e.stopPropagation()}
        style={{
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <div className={receCss.custModelHeader} style={{ padding: '10px 20px 10px 10px'}}>
          <div className={receCss.headerLeftSection}>
            <BackArrowButton onClick={handleBackClick} />
            <div className={receCss.custModelHeaderLabel}>
              Map Columns to User Fields
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <button  
              type="button"
              onClick={onOpenImportMapping}
              className={`${receCss.importMappingBtn} ${receCss.cursiorPointer}`}
              >
              Import mapping
            </button>

            <div className={receCss.custmCursor}>
              <CustModeLCloseIcon
                className={`${receCss.custModelHeaderCloseicon} ${receCss.cursiorPointer}`}
                onClick={() => {
                  setReceivablesMapping(false);
                }}
              />
            </div>
          </div>
        </div>

        <div
          className={`${receCss.cutModelBodyContainer} ${receCss.customscroll}`}
          style={{
            flex: 1,
            overflowY: "auto",
            overflowX: "hidden",
            padding: "20px 24px",
          }}
        >
          <div
            className={receCss.selectRowContainer}
            style={{ gap: "16px", marginBottom: "0" }}
          >
            <div className={receCss.selectContainer}>
              <div className={receCss.custmLabel}>
                <span className={receCss.reqiredField}>*</span>
                Customer ID
              </div>
                <Select
                components={{ IndicatorSeparator: () => null }}
                value={getSelectedOption("customerID")}
                onChange={(opt) =>
                handleSelectChange("customerID", opt)
                }
                options={ReceivablesColumnMap}
                placeholder="Select Customer ID"
                name="customerID"
                className={`mt-0 ${receCss.scenarioSelect}`}
                classNamePrefix="select"
                styles={customStyles}
                isClearable={false}
                isSearchable={true}
                menuPosition="fixed"
                menuPlacement="auto"
                />
            </div>
            <div className={receCss.selectContainer}>
              <div className={receCss.custmLabel}>
                <span className={receCss.reqiredField}>*</span>
                Customer Name
              </div>
              <Select
                components={{ IndicatorSeparator: () => null }}
                value={getSelectedOption("customerName")}
                onChange={(opt) => handleSelectChange("customerName", opt)}
                options={ReceivablesColumnMap}
                placeholder="Select Customer Name"
                name="customerName"
                className={`mt-0 ${receCss.scenarioSelect}`}
                classNamePrefix="select"
                styles={customStyles}
                isClearable={false}
                isSearchable={true}
                menuPosition="fixed"
                menuPlacement="auto"
              />
            </div>
            <div className={receCss.selectContainer}>
              <div className={receCss.custmLabel}>
                <span className={receCss.reqiredField}>*</span>
                Doc Date
              </div>
              <Select
                components={{ IndicatorSeparator: () => null }}
                value={getSelectedOption("docDate")}
                onChange={(opt) => handleSelectChange("docDate", opt)}
                options={ReceivablesColumnMap}
                placeholder="Select Doc Date"
                name="docDate"
                className={`mt-0 ${receCss.scenarioSelect}`}
                classNamePrefix="select"
                styles={customStyles}
                isClearable={false}
                isSearchable={true}
                menuPosition="fixed"
                menuPlacement="auto"
                />
            </div>
          </div>

          <div
            className={receCss.selectRowContainer}
            style={{ gap: "16px", marginBottom: "0" }}
          >
            <div className={receCss.selectContainer}>
              <div className={receCss.custmLabel}>
                <span className={receCss.reqiredField}>*</span>
                Due Days
              </div>
              <Select
                components={{ IndicatorSeparator: () => null }}
                value={getSelectedOption("dueDays")}
                onChange={(opt) => handleSelectChange("dueDays", opt)}
                options={getOptions()}
                placeholder="Select Due Days"
                name="dueDays"
                className={`mt-0 ${receCss.scenarioSelect}`}
                classNamePrefix="select"
                styles={customStyles}
                isClearable={false}
                isSearchable={true}
                menuPosition="fixed"
                menuPlacement="auto"
               />
            </div>
            <div className={receCss.selectContainer}>
              <div className={receCss.custmLabel}>
                <span className={receCss.reqiredField}>*</span>
                Due Date
              </div>
              <Select
                components={{ IndicatorSeparator: () => null }}
                value={getSelectedOption("dueDate")}
                options={getOptions()}
                onChange={(opt) => handleSelectChange("dueDate", opt)}
                placeholder="Select Due Date"
                name="dueDate"
                className={`mt-0 ${receCss.scenarioSelect}`}
                classNamePrefix="select"
                styles={customStyles}
                isClearable={false}
                isSearchable={true}
                menuPosition="fixed"
                menuPlacement="auto"
                />
            </div>
            <div className={receCss.selectContainer}>
              <div className={receCss.custmLabel}>
                <span className={receCss.reqiredField}>*</span>
                Foreign Currency
              </div>
              <Select
                components={{ IndicatorSeparator: () => null }}
                value={getSelectedOption("foreignCurrency")}
                options={getOptions()}
                onChange={(opt) => handleSelectChange("foreignCurrency", opt)}
                placeholder="Select Foreign Currency"
                name="foreignCurrency"
                className={`mt-0 ${receCss.scenarioSelect}`}
                classNamePrefix="select"
                styles={customStyles}
                isClearable={false}
                isSearchable={true}
                menuPosition="fixed"
                menuPlacement="auto"
               />
            </div>
          </div>

          <div
            className={receCss.selectRowContainer}
            style={{ gap: "16px", marginBottom: "0" }}
          >
            <div className={receCss.selectContainer}>
              <div className={receCss.custmLabel}>
                <span className={receCss.reqiredField}>*</span>
                Exchange currency value
                </div>
              <Select
                components={{ IndicatorSeparator: () => null }}
                value={getSelectedOption("exchangeCurrencyValue")}
                options={getOptions()}
                onChange={(opt) => handleSelectChange("exchangeCurrencyValue", opt)}
                placeholder="Select Exchange currency.."
                name="exchangeCurrencyValue"
                className={`mt-0 ${receCss.scenarioSelect}`}
                classNamePrefix="select"
                styles={customStyles}
                isClearable={false}
                isSearchable={true}
                menuPosition="fixed"
                menuPlacement="auto"
                />
            </div>
            <div className={receCss.selectContainer}>
              <div className={receCss.custmLabel}>
                <span className={receCss.reqiredField}>*</span>
                GL Account Code
              </div>
              <Select
                components={{ IndicatorSeparator: () => null }}
                value={getSelectedOption("GLAccountCode")}
                options={getOptions()}
                onChange={(opt) => handleSelectChange("GLAccountCode", opt)}
                placeholder="Select GL Account Code"
                name="GLAccountCode"
                className={`mt-0 ${receCss.scenarioSelect}`}
                classNamePrefix="select"
                styles={customStyles}
                isClearable={false}
                isSearchable={true}
                menuPosition="fixed"
                menuPlacement="auto"
                />
            </div>
            <div className={receCss.selectContainer}>
              <div className={receCss.custmLabel}>
                <span className={receCss.reqiredField}>*</span>
                Business
              </div>
              <Select
                components={{ IndicatorSeparator: () => null }}
                value={getSelectedOption("business")}
                options={getOptions()}
                onChange={(opt) => handleSelectChange("business", opt)}
                placeholder="Select Business"
                name="business"
                className={`mt-0 ${receCss.scenarioSelect}`}
                classNamePrefix="select"
                styles={customStyles}
                isClearable={false}
                isSearchable={true}
                menuPosition="fixed"
                menuPlacement="auto"
                />
            </div>
          </div>

          <div
            className={receCss.selectRowContainer}
            style={{ gap: "16px", marginBottom: "0" }}
          >
            <div className={receCss.selectContainer}>
              <div className={receCss.custmLabel}>
                <span className={receCss.reqiredField}>*</span>
                Business Person Responsible
              </div>
              <Select
                components={{ IndicatorSeparator: () => null }}
                value={getSelectedOption("businessPersonResponsible")}
                options={getOptions()}
                onChange={(opt) => handleSelectChange("businessPersonResponsible", opt)}
                placeholder="Select Business Person.."
                name="businessPersonResponsible"
                className={`mt-0 ${receCss.scenarioSelect}`}
                classNamePrefix="select"
                styles={customStyles}
                isClearable={false}
                isSearchable={true}
                menuPosition="fixed"
                menuPlacement="auto"
                />
            </div>
            <div className={receCss.selectContainer}>
              <div className={receCss.custmLabel}>
                <span className={receCss.reqiredField}>*</span>
                Provision
              </div>
              <Select
                components={{ IndicatorSeparator: () => null }}
                value={getSelectedOption("provision")}
                options={getOptions()}
                onChange={(opt) => handleSelectChange("provision", opt)}
                placeholder="Select Provision"
                name="provision"
                className={`mt-0 ${receCss.scenarioSelect}`}
                classNamePrefix="select"
                styles={customStyles}
                isClearable={false}
                isSearchable={true}
                menuPosition="fixed"
                menuPlacement="auto"
              />
            </div>
            <div className={receCss.selectContainer}>
              <div className={receCss.custmLabel}>
                <span className={receCss.reqiredField}>*</span>
                Category
              </div>
              <Select
                components={{ IndicatorSeparator: () => null }}
                value={getSelectedOption("category")}
                options={getOptions()}
                onChange={(opt) => handleSelectChange("category", opt)}          placeholder="Select Category"
                name="category"
                className={`mt-0 ${receCss.scenarioSelect}`}
                classNamePrefix="select"
                styles={customStyles}
                isClearable={false}
                isSearchable={true}
                menuPosition="fixed"
                menuPlacement="auto"
                />
            </div>

          </div>
          <div  className={receCss.selectRowContainer}  style={{ gap: "16px", marginBottom: "0" }}>

          <div className={receCss.selectContainer}>
           <div className={receCss.custmLabel}>
           <span className={receCss.reqiredField}>*</span>
             Outstanding Amount
           </div>
           <Select
            components={{ IndicatorSeparator: () => null }}
            value={getSelectedOption("outstandingAmount")}
            options={getOptions()}
            onChange={(opt) => handleSelectChange("outstandingAmount", opt)} 
            placeholder="Select Outstanding Amount"
            name="outstandingAmount"
            className={`mt-0 ${receCss.scenarioSelect}`}
            classNamePrefix="select"
            styles={customStyles}
            isClearable={false}
            isSearchable={true}
            menuPosition="fixed"
            menuPlacement="auto"
            />
          </div>

 
  <div className={receCss.selectContainer}>
    <div className={receCss.custmLabel}>
      <span className={receCss.reqiredField}>*</span>
      Invoice Amount
    </div>
    <Select
      components={{ IndicatorSeparator: () => null }}
      value={getSelectedOption("invoiceAmount")}
      options={getOptions()}
      onChange={(opt) => handleSelectChange("invoiceAmount", opt)}
      placeholder="Select Invoice Amount"
      name="invoiceAmount"
      className={`mt-0 ${receCss.scenarioSelect}`}
      classNamePrefix="select"
      styles={customStyles}
      isClearable={false}
      isSearchable={true}
      menuPosition="fixed"
      menuPlacement="auto"
      />
  </div>

  <div className={receCss.selectContainer}>
    <div className={receCss.custmLabel}>
      <span className={receCss.reqiredField}>*</span>
      Invoice Number
    </div>
    <Select
      components={{ IndicatorSeparator: () => null }}
      value={getSelectedOption("invoiceNumber")}
      options={getOptions()}
      onChange={(opt) => handleSelectChange("invoiceNumber", opt)}
      placeholder="Select Invoice Number"
      name="invoiceNumber"
      className={`mt-0 ${receCss.scenarioSelect}`}
      classNamePrefix="select"
      styles={customStyles}
      isClearable={false}
      isSearchable={true}
      menuPosition="fixed"
      menuPlacement="auto"
      />
  </div>
 </div>
 <div className={receCss.selectRowContainer} style={{ gap: "16px", marginBottom: "16px" }}>
  <div className={receCss.selectContainer}>
    <div className={receCss.custmLabel}>
      <span className={receCss.reqiredField}>*</span>
      Invoice Date
    </div>
   <Select
      components={{ IndicatorSeparator: () => null }}
      value={getSelectedOption("invoiceDate")}
      options={getOptions()}
      onChange={(opt) => handleSelectChange("invoiceDate", opt)}
      placeholder="Select Invoice Date"
      name="invoiceDate"
      className={`mt-0 ${receCss.scenarioSelect}`}
      classNamePrefix="select"
      styles={customStyles}
      isClearable={false}
      isSearchable={true}
      menuPosition="fixed"
      menuPlacement="auto"
      />
  </div>
 </div>
</div>

 

        <div className={receCss.cutModelFooterContainer}>
          <button
            type="button"
            onClick={() => {
              setReceivablesMapping(false);
            }}
            className={receCss.custModelFooterBtnSecondary}
          >
            Cancel
          </button>
          <div style={{ display: "flex", gap: "10px" }}>
            <button
              type="button"
              onClick={openSaveMappingPopup}
              className={receCss.custModelFooterBtnSecondary}
            >
              Save Mapping
            </button>

            <button
              type="button"
              onClick={continueWithColumnMapping}
              className={receCss.custModelFooterBtnPrimary}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
      {showSaveMapping && (
        <SaveMappingPopup
          onClose={() => setShowSaveMapping(false)}
          companyId={companyId}
          onSave={handleSaveMappingWithName}
        />
      )}
    </div>
  );
};

const ReceivablesERPItemsModel = ({
  selectedCardId,
  setSelectedCardId,
  erpList,
  setreceivablesERPModel,
  setReceivableId,
}) => {
  return (
    <div
      className={`${receCss.cutModelForDragLaonsIrac} custmfadein`}
      onClick={() => {}}
    >
      <div
        className={receCss.cutmModelMainContainerSecond}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={receCss.custModelHeader} style={{ padding: '10px 20px 10px 10px'}}>
          <div className={receCss.custModelHeaderLabel}>
            Add Receivable Register
          </div>
          <div className={receCss.custmCursor}>
            <CustModeLCloseIcon
              className={`${receCss.custModelHeaderCloseicon} ${receCss.cursiorPointer}`}
              onClick={() => {
                setreceivablesERPModel(false);
              }}
            />
          </div>
        </div>

        <div className={receCss.cutModelBodyContainer}>
          <div className={receCss.selectRowErpContainer}>
            {/* 
                        <div className={receCss.erpCard}>
                            <div className={receCss.erpcardHeader}>
                                <div className={receCss.erpcardHeading}>
                                    Package Name
                                </div>
                                <div>
                                    <ErpCardDots />
                                </div>
                            </div>
                            <div className={receCss.erpcardBody}>
                                <div className={receCss.dateContainer}>
                                    <div className={receCss.calenderContainerWrapper}>
                                        <CalenderIcon className={receCss.iconSize} /> &nbsp; Feb 11, 2025
                                    </div>
                                    &nbsp;
                                    &nbsp;
                                    <div className={receCss.toTxt}>To</div>
                                    &nbsp;
                                    &nbsp;
                                    <div className={receCss.calenderContainerWrapper}>
                                        <CalenderIcon className={receCss.iconSize} /> &nbsp; Aug 15, 2025
                                    </div>
                                </div>
                                <div className={receCss.dFlex}>
                                    <ErpClock className={receCss.iconSize} /> 
                                    &nbsp;
                                    Apr 10, 2025 &nbsp; 08:34
                                </div>
                                <div className={receCss.dFlex}>
                                    <img className={receCss.userIcon} src={UserTwoImg} />
                                    &nbsp;
                                    &nbsp;
                                    <div>Adrienne Vossler</div>
                                </div>
                            </div>
                        </div> */}

            {erpList.map((item) => (
              <div
                key={item._id}
                className={`${receCss.erpCard} ${
                  selectedCardId === item._id ? receCss.selectedCard : ""
                }`}
                onClick={() => setSelectedCardId(item._id)}
              >
                <div className={receCss.erpcardHeader}>
                  <div className={receCss.erpcardHeading}>
                    {item?.name || "Package Name"}
                  </div>
                  <div>
                    <ErpCardDots />
                  </div>
                </div>

                <div className={receCss.erpcardBody}>
                  <div className={receCss.dateContainer}>
                    <div className={receCss.calenderContainerWrapper}>
                      <CalenderIcon className={receCss.iconSize} /> &nbsp;
                      {new Date(item.datecreated).toDateString()}
                    </div>
                  </div>

                  <div className={receCss.dFlex}>
                    <ErpClock className={receCss.iconSize} />
                    &nbsp;
                    {new Date(item.datecreated).toLocaleString()}
                  </div>

                  <div className={receCss.dFlex}>
                    <img className={receCss.userIcon} src={UserTwoImg} />
                    &nbsp;&nbsp;
                    <div>Adrienne Vossler</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={receCss.cutModelFooterContainer}>
          <button
            type="button"
            onClick={() => {
              setreceivablesERPModel(false);
            }}
            className={receCss.custModelFooterBtnSecondary}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => {
              setReceivableId();
            }}
            className={receCss.custModelFooterBtnPrimary}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
    
  );
};

const SubReceivablesMappingModel = ({
  setsubReceivablesMapping,
  subReceivablesMapping,
  subMappingActiveTab,
  setsubMappingActiveTab,
  perCategoryLabels,
  perCategoryFields,
  // perProductClassfLables,
  // perProductClassfFields,
  perCurrencyLables,
  perCurrencyFields,
  handleSetSelectChange,
  selectedSubMappingData,
  setSelectedSubMappingData,
  categoryLabels,
  currencyLabels,
  saveSubMapping,
  showAddField,
  setShowAddField,
  onBackToMapping,
  setReceivablesMapping,
  continueWithColumnMapping,
  
}) => {
  const handleBackClick = () => {
    setsubReceivablesMapping(false);
    if (setReceivablesMapping) {
      setReceivablesMapping(true);
    } else if (onBackToMapping) {
      onBackToMapping();
    }
  };

  return (
    <div
      className={`${receCss.cutModelForDragLaonsIrac} custmfadein`}
      onClick={() => {}}
    >
      <div
        className={receCss.cutmModelMainContainerThird}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={receCss.custModelHeader} style={{ padding: '10px 20px 10px 10px'}}>
          <div className={receCss.headerLeftSection}>
            <BackArrowButton onClick={handleBackClick} />
            <div className={receCss.custModelHeaderLabel}>Sub mapping</div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <button
              type="button"
              //onClick={importSubMapping}
              className={`${receCss.importMappingBtn} ${receCss.cursiorPointer}`}
            >
              Import mapping
            </button>
            <div className={receCss.custModelAddButton}>
              <button
                className={receCss.addFieldButton}
                onClick={() => setShowAddField(true)}
              >
                <span className={receCss.AddText}>
                  <img src={AddIcon} alt="add" className={receCss.addIconImg} />
                  Add Field
                </span>
              </button>
            </div>
            <div className={receCss.custmCursor}>
              <CustModeLCloseIcon
                className={`${receCss.custModelHeaderCloseicon} ${receCss.cursiorPointer}`}
                onClick={() => {
                  setsubReceivablesMapping(false);
                }}
              />
            </div>
          </div>
        </div>
        {showAddField && <AddField onClose={() => setShowAddField(false)} />}

        {/* subMappingActiveTab, setsubMappingActiveTab */}
        <div className={receCss.wrapperContainerSubMap}>
          <div className={receCss.loansSubMapTabsContainer}>
            <div
              onClick={() => {
                setsubMappingActiveTab(1);
              }}
              className={
                subMappingActiveTab === 1
                  ? receCss.subMapTabsActive
                  : receCss.subMapTabs
              }
            >
              Category
            </div>
            <div
              onClick={() => {
                setsubMappingActiveTab(2);
              }}
              className={
                subMappingActiveTab === 2
                  ? receCss.subMapTabsActive
                  : receCss.subMapTabs
              }
            >
              Currency
            </div>
            {/* <div onClick={() => {setsubMappingActiveTab(3)}} className={ subMappingActiveTab === 3 ? receCss.subMapTabsActive : receCss.subMapTabs }>Product Classification</div> */}
          </div>
          {subMappingActiveTab === 1 && (
            <div className={receCss.selectContainerWrapper}>
              {perCategoryLabels?.map((label, index) => {
                const categoryValue = categoryLabels[index] || "";

                const existingSelection =
                  selectedSubMappingData.categorySubmap?.find(
                    (item) => item.key === label
                  );

                const currentValue =
                  existingSelection?.values?.[0] || categoryValue;

                return (
                  <div className={receCss.selectContainerTab} key={index}>
                    <div className={receCss.categoryLabelContainer}>
                      <span className={receCss.categoryLabel}>{label}</span>
                    </div>
                    <Select
                      components={{ IndicatorSeparator: () => null }}
                      key={index}
                      value={
                        currentValue !== null &&
                        currentValue !== undefined &&
                        currentValue !== ""
                          ? perCategoryFields?.find(
                              (opt) => opt.value === currentValue
                            ) || null
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleSetSelectChange(selectedOption, index, "Category")
                      }
                      options={perCategoryFields}
                      placeholder="Select Excel Column"
                      name={`category-${index}`}
                      className={`mt-0 ${receCss.scenarioSelect}`}
                      classNamePrefix="select"
                      styles={customStyles}
                      isClearable={false}
                      isSearchable={true}
                    />
                  </div>
                );
              })}
            </div>
          )}

          {subMappingActiveTab === 2 && (
            <div className={receCss.currencyMappingContainer}>
              <div className={receCss.infoMessageContainer}>
                <div className={receCss.infoIcon}>
                  <img src={circle} alt="icon" />
                </div>
                <div className={receCss.infoText}>
                  You may map multiple columns to a single field, but once a
                  column is mapped, it cannot be assigned to any other field.
                </div>
              </div>

              <div className={receCss.currencyMappingList}>
                {perCurrencyLables?.map((label, index) => {
                  const existingSelection =
                    selectedSubMappingData.currencySubmap?.find(
                      (item) => item.key === label
                    );

                  const selectedColumnName = currencyLabels[index] || "";
                  const exchangeRate = existingSelection?.values || "";

                  return (
                    <React.Fragment key={index}>
                      <div className={receCss.currencyColumn}>
                        <div className={receCss.fieldLabel}>{label}</div>
                        <Select
                          components={{ IndicatorSeparator: () => null }}
                          value={
                            selectedColumnName
                              ? perCurrencyFields?.find(
                                  (opt) => opt.value === selectedColumnName
                                ) || null
                              : null
                          }
                          onChange={(selectedOption) =>
                            handleSetSelectChange(
                              selectedOption,
                              index,
                              "Currency"
                            )
                          }
                          options={perCurrencyFields}
                          placeholder="Map Column"
                          name={`currency-${index}`}
                          className={receCss.scenarioSelect}
                          classNamePrefix="select"
                          styles={customStyles}
                          isClearable={false}
                          isSearchable={true}
                        />
                      </div>

                      <div className={receCss.closingRateColumn}>
                        <div className={receCss.fieldLabel}>Closing Rate</div>
                        <input
                          type="number"
                          step="0.01"
                          placeholder="Enter exchange rate"
                          value={
                            selectedSubMappingData.currencySubmap[index]
                              ?.exchangeRate || ""
                          }
                          onChange={(e) => {
                            const rate = Number(e.target.value);

                            setSelectedSubMappingData((prev) => {
                              const updated = [...(prev.currencySubmap || [])];

                              updated[index] = {
                                ...updated[index],
                                currencyCode: label,
                                exchangeRate: rate,
                              };

                              return {
                                ...prev,
                                currencySubmap: updated,
                              };
                            });
                          }}
                          className={receCss.exchangeRateInput}
                        />
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        <div className={receCss.cutModelFooterContainer}>
          <button
            type="button"
            onClick={() => {
              setsubReceivablesMapping(false);
            }}
            className={receCss.custModelFooterBtnSecondary}
          >
            Cancel
          </button>

          <div style={{ display: "flex", gap: "10px" }}>
            <button
              type="button"
              className={receCss.custModelFooterBtnSecondary}
            >
              Save Mapping
            </button>

            <button
              type="button"
              onClick={saveSubMapping}
              className={receCss.custModelFooterBtnPrimary}
            >
              Submit Submapping
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "#f4faf5",
    borderColor: "#c2e6d1",
    color: "#b3c0bd",
    boxShadow: state.isFocused ? "0 0 0 1px #c2e6d1" : "none",
    borderWidth: "1px",
    borderRadius: "10px",
    "&:hover": {
      borderColor: "#b3c0bd",
    },
    minHeight: "38px",
    height: "38px",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "2px 8px",
    paddingTop: "1px",
  }),
  input: (provided) => ({
    ...provided,
    color: "#b3c0bd",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#b3c0bd",
    fontSize: "14px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#4d6d64",
    fontSize: "14px",
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#e0f5e9",
    borderRadius: "0.25rem",
    border: "1px solid #c2e6d1",
    width: "fit-content",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#4d6d64",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#b3c0bd",
    ":hover": {
      backgroundColor: "#c2e6d1",
      color: "#4f665f",
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    color: "#b3c0bd",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#205a46",
  }),
  clearIndicator: (provided) => ({
    ...provided,
    color: "#b3c0bd",
    ":hover": {
      color: "#4f665f",
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#ffffff",
    border: "1px solid #c2e6d1",
    borderRadius: "10px",
    boxShadow: "0 0 0 1px #c2e6d1",
    marginTop: "6px",
    zIndex: 10,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: "4px",
    borderRadius: "10px",
  }),
  //   option: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: state.isSelected
  //       ? '#c2e6d1'
  //       : state.isFocused
  //       ? '#f4faf5'
  //       : 'transparent',
  //     color: '#4f665f',
  //     padding: '10px 12px',
  //     cursor: 'pointer',
  //     fontSize: '14px',
  //     borderRadius: '8px',
  //     // margin: '4px 6px',
  //   }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#f4faf5" : "transparent",
    color: "#4f665f",
    padding: "10px 12px",
    cursor: "pointer",
    fontSize: "14px",
    borderRadius: "8px",
  }),

  noOptionsMessage: (provided) => ({
    ...provided,
    color: "#b3c0bd",
    padding: "8px 12px",
  }),
};
